import { render, staticRenderFns } from "./PatientsEditInformation.vue?vue&type=template&id=6b3cecad&scoped=true"
import script from "./PatientsEditInformation.vue?vue&type=script&lang=js"
export * from "./PatientsEditInformation.vue?vue&type=script&lang=js"
import style0 from "./PatientsEditInformation.vue?vue&type=style&index=0&id=6b3cecad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3cecad",
  null
  
)

export default component.exports